import {urlByLang} from './urlByLang';
import {configStore} from 'app/store/global';

export const replaceLocale = (path: string, newLocale: string, currentLocale?: string): string => {
    const newUrl = urlByLang(newLocale);
    return path.replace(`/${urlByLang(currentLocale) || configStore.CURRENT_LOCALE}`, newUrl === '' ? '' : `/${newUrl}`);
};
